import React, { useRef } from 'react'
import { UploadIcon } from 'lucide-react'
import styles from './FileInput.module.scss'

interface FileInputProps {
  onChange: (file: File | null) => void
  accept?: string
  preview?: string | null
  disabled?: boolean
  className?: never
}

export const FileInput: React.FC<FileInputProps> = ({
  onChange, accept = 'image/*', preview, disabled,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.files?.[0] ?? null)
  }

  return (
    <div onClick={() => inputRef.current?.click()} className={styles.dropzone}>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        disabled={disabled}
        className={styles.hidden}
      />
      {preview ? (
        <img src={preview} alt="Preview" className={styles.preview} />
      ) : (
        <>
          <UploadIcon className={styles.icon} />
          <p className={styles.text}>Click to upload or drag and drop</p>
        </>
      )}
    </div>
  )
}
